/**
 * 仙途 · 文字修仙 — 入口文件
 * 初始化 UI 管理器并启动游戏
 */

import { UIManager } from './ui/UIManager';

// 启动游戏
const uiManager = new UIManager();
uiManager.start();

// 页面关闭前自动存档
window.addEventListener('beforeunload', () => {
  uiManager.stop();
});

// 页面隐藏时自动存档（移动端切换应用）
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    uiManager.stop();
  }
});
